// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
  --headerHeight:4rem;
  --headerHeightMobile:calc(var(--headerHeight)*0.8);
}

.header-logged-out{
  height:3.2rem;
  background:#fff;
}

@media (width > 640px){

.header-logged-out{
    height:4rem
}
  }

.help-button{
  position:absolute;
  top:0;
  right:1rem;
  display:flex;
  align-items:center;
  height:3.2rem;
}

@media (width > 640px){

.help-button{
    height:4rem
}
  }

.help-button button{
    padding:0.25rem;
    background:none;
    border:none;
    border-radius:0.25rem;
  }

.help-button button:hover{
      background-color:rgb(0, 0, 0, 0.08);
    }

.help-button button:active{
      background-color:rgb(0, 0, 0, 0.1);
    }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
